import type { NuxtApp } from '#app';
import formatMoney from '@/utils/formatMoney';

export const formatPrice = (value: number, nuxtApp: NuxtApp) => formatMoney(value / 100, nuxtApp.$i18n.locale.value);

export default defineNuxtPlugin((nuxtApp) => {
  return {
      provide: {
        formatPrice: (value: number) => formatPrice(value, nuxtApp as NuxtApp)
      }
  }
})